import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Input('clickOutside') isOpen: boolean;
  @Output('clickOutsideChange') isOpenChange = new EventEmitter<boolean>();

  private clickedOnce = false;
  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  private onClick(target: HTMLElement): void {
    if (!this.clickedOnce) {
      this.clickedOnce = true;
      return;
    }

    const clickedInside = this.elementRef.nativeElement.parentElement.contains(target);
    if (!clickedInside && this.isOpen) {
      this.isOpenChange.emit(false);
    }
  }
}
